export default "__VITE_ASSET__BYTJyHfG__"